import React from "react";
import PropTypes from "prop-types";
// import "./PercentageIndicator.css";
import styles from './PercentageIndicator.module.css';

const WithOutPercentageIndicator = ({ percentage }) => (
    <div className={styles.indicator_card}>
      <div className={styles.percentage_text}>
        {percentage}
      </div>
    </div>
  );

WithOutPercentageIndicator.propTypes = {
  percentage: PropTypes.number.isRequired
};

export default WithOutPercentageIndicator;